import React, { useContext, useRef } from 'react';
import Collect from '@fiverr-private/collect';
import { Popover } from '@fiverr-private/fit';
import { Resource, OnCollectionClickedCallback } from '../../../../types/collections';
import { CollectionsContext } from '../../context/CollectionsContext';
import { useX } from './hooks/useX';

const MIN_X = 280;

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
const BOTTOM_LEFT: string = Popover.POSITIONS.BOTTOM_LEFT;
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
const BOTTOM_RIGHT: string = Popover.POSITIONS.BOTTOM_RIGHT;

interface InspireSaveButtonProps {
  /**
   * Inspire delivery ID
   */
  id: string;
  onSaved: () => void;
  onUnSaved: () => void;
}

export const InspireSaveButton = ({ id, onSaved, onUnSaved }: InspireSaveButtonProps) => {
  const { loaded, collections, onUpdateCollections, onCollected } = useContext(CollectionsContext);

  const resource: Resource = { id, type: Collect.RESOURCE_TYPES.INSPIRE_DELIVERY };

  const onCollectionClickedCallback: OnCollectionClickedCallback = ({ isCollected: prevIsCollected }) => {
    const isCollected = !prevIsCollected;

    if (isCollected) {
      onSaved();
    } else {
      onUnSaved();
    }

    if (onCollected) {
      onCollected(id, isCollected);
    }
  };

  const nullRef = useRef<Element>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const x = useX(loaded ? containerRef : nullRef);
  const menuPosition = x === null || x > MIN_X ? BOTTOM_RIGHT : BOTTOM_LEFT;

  if (!loaded) {
    return null;
  }

  return (
    <div ref={containerRef}>
      <Collect
        inspireVariant
        collections={collections}
        resource={resource}
        showMenu
        menuPosition={menuPosition}
        onUpdateCollections={onUpdateCollections}
        onCollectionClickedCallback={onCollectionClickedCallback}
        allowMenuOverflow
      />
    </div>
  );
};
